import styled from 'styled-components';
import Image from '@stencil/image';
import {SectionHeader} from '../../../CommonStyleUtils/dwebCommon.styles';

export const PopularDestMainWrapper = styled.section(
  props => `
    margin-top: ${props.theme.spacing.xxlarge};
  `,
);

export const PopularDestHeaderSubText = styled.p(
  props => `
      display: flex;
      font-size: ${props.theme.font.custom(16)};
      color: ${props.theme.colors.downriver.dark};
      padding: ${props.theme.spacing.small} 0 0;
    `,
);

export const PopularImageOuterWrapper = styled.div(
  props => `
    display: flex;
    margin-top: ${props.theme.spacing.xlarge};
    margin-bottom: ${props.theme.spacing.xlarge};
    `,
);

export const PopularBigImageWrapper = styled.a(
  props => `
    position: relative;
    margin-right:${props.theme.spacing.xxlarge};
  `,
);

export const PopularBigImage = styled(Image)(
  props => `
        width: 37rem;
        height: 44rem;
        display: flex;
        position: relative;
        border-radius: ${props.theme.misc.borderRadius.xxlarge};
    `,
);

export const PopularImageOverlayWrap = styled.div(
  props => `
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(${props.theme.colors.shadow.light}, ${props.theme.colors.shadow.dark});
        border-radius: ${props.theme.misc.borderRadius.xxlarge};
        flex-direction: column;
        justify-content: flex-end;
        display: flex;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.xlarge};
        cursor: pointer;
    `,
);

export const OverlayMainText = styled(SectionHeader)(
  props => `
      color: ${props.theme.colors.goWhite.base};
    `,
);

export const OverlaySubText = styled.p(
  props => `
      font-size: ${props.theme.font.custom(14)};
      color: ${props.theme.colors.goWhite.base};
    `,
);

export const PopularSmallImageOuterWrapper = styled.div(
  props => `
        width: 39rem;
        height: 44rem;
        display: flex;
        position: relative;
        justify-content: space-between;
        flex-direction: column;
        cursor: pointer;
        margin-right:${props.theme.spacing.xxlarge};
    `,
);

export const PopularSmallImageWrapper = styled.a(
  props => `
    display: flex;
    position: relative;
  `,
);

export const PopularSmallImage = styled(Image)(
  props => `
      width: 39rem;
      height: 21rem;
      display: flex;
      position: relative;
      border-radius: ${props.theme.misc.borderRadius.xxlarge};
      object-fit: cover;
  `,
);
